export default __webpack_public_path__ + "static/media/minus.093dbbc8.svg";